import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';
import { StoragePremiumServiceSubscriptionResource } from 'app/_resources/storage-premium-service-subscription.resource';
import { StorageEnums } from 'app/storage-offer/storage-enum-values';

class SsoPremiumServicesWizardServicePackageComponentCtrl
    implements ng.IController
{
    packages: StoragePremiumServiceSubscriptionPackageDto[];
    enums: StorageEnums = StorageEnums;
    wizardCtrl: mgoAngularWizard.Wizard<StoragePremiumServiceSubscriptionCreationDto>;

    constructor(
        private storagePremiumServiceSubscriptionResource: StoragePremiumServiceSubscriptionResource
    ) {}

    $onInit(): void {
        this.storagePremiumServiceSubscriptionResource.getPackages(
            (res: StoragePremiumServiceSubscriptionPackageDto[]) => {
                this.packages = res;
            }
        );
    }

    choose(servicePackage: StoragePremiumServicePackage) {
        this.wizardCtrl.context.servicePackage = servicePackage;
        this.wizardCtrl.next();
    }
}

angular.module('app').component('pkpSsoPremiumServicesWizardServicePackage', {
    controller: SsoPremiumServicesWizardServicePackageComponentCtrl,
    template:
        require('app/sso-premium-services-wizard/sso-premium-services-wizard-service-package.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {
        servicePackage: '=',
        back: '&',
        disableChoice: '=',
        isUpgrade: '='
    }
});
